import React from 'react';
import PropTypes from 'prop-types';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { ResponsiveImage } from "../../media/ResponsiveImage";
import { BOOK_NOW, USE_COUPON_CODE } from "../../../utils/default-strings";
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { Button } from "../../elements/Button";
import { testidFactory } from "../../../utils/testid";
var TEST_ID_PREFIX = 'minimalpromotion';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var backgroundImageHeight = _ref.backgroundImageHeight,
      backgroundImageSizes = _ref.backgroundImageSizes,
      backgroundImageSrcSet = _ref.backgroundImageSrcSet,
      backgroundImageUrl = _ref.backgroundImageUrl,
      backgroundImageWidth = _ref.backgroundImageWidth,
      discountAmount = _ref.discountAmount,
      discountCode = _ref.discountCode,
      discountCodeParagraphText = _ref.discountCodeParagraphText,
      buttonText = _ref.buttonText,
      headingText = _ref.headingText,
      onClick = _ref.onClick,
      placeholderBackgroundImage = _ref.placeholderBackgroundImage;
  return React.createElement(Segment, {
    basic: true,
    className: "is-minimal-promotion"
  }, !!backgroundImageUrl && React.createElement(ResponsiveImage, {
    "data-testid": testid('image'),
    imageHeight: backgroundImageHeight,
    imageUrl: backgroundImageUrl,
    imageWidth: backgroundImageWidth,
    placeholderImageUrl: placeholderBackgroundImage,
    sizes: backgroundImageSizes,
    srcSet: backgroundImageSrcSet
  }), React.createElement("div", {
    className: "content-section"
  }, headingText && React.createElement(Heading, {
    "data-testid": testid('heading')
  }, headingText), React.createElement(Heading, {
    size: "huge"
  }, discountAmount), React.createElement(Paragraph, {
    size: "tiny",
    weight: "light"
  }, discountCodeParagraphText), React.createElement(Paragraph, null, discountCode), React.createElement(Button, {
    isRounded: true,
    onClick: onClick
  }, buttonText)));
};
Component.displayName = 'MinimalPromotion';
Component.defaultProps = {
  backgroundImageHeight: undefined,
  backgroundImageSizes: undefined,
  backgroundImageSrcSet: undefined,
  backgroundImageWidth: undefined,
  backgroundImageUrl: undefined,
  discountCode: undefined,
  discountCodeParagraphText: USE_COUPON_CODE,
  buttonText: BOOK_NOW,
  headingText: undefined,
  placeholderBackgroundImage: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundImageHeight: PropTypes.number,
  backgroundImageSizes: PropTypes.string,
  backgroundImageSrcSet: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  backgroundImageWidth: PropTypes.number,
  buttonText: PropTypes.string,
  discountAmount: PropTypes.string.isRequired,
  discountCode: PropTypes.string,
  discountCodeParagraphText: PropTypes.string,
  headingText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  placeholderBackgroundImage: PropTypes.string
} : {};